import {
  STATUS_ICON_CHECK_O,
  STATUS_ICON_LOADING,
  STATUS_ICON_CLOCK,
  STATUS_ICON_TIMES_O,
  STATUS_ICON_WARNING_O
} from '@/common/utils/statuses';
import { ClusterRegistration, TaskState } from '@schema';
import computedLocale from '@/common/utils/computedLocale';
import i18n from '@/common/i18n';

export const CONNECTION_STATUS = {
  UNKNOWN: 'unknown',
  HEALTHY: 'healthy',
  FAILED: 'failed',
  CONFIGURING: 'configuring',
  PENDING: 'pending',
  REGISTRATION_FAILED: 'registration_failed'
} as const;

export const statusMap = {
  [TaskState.RUNNING]: CONNECTION_STATUS.CONFIGURING,
  [TaskState.SUCCESS]: CONNECTION_STATUS.HEALTHY,
  [TaskState.FAILED]: CONNECTION_STATUS.FAILED
} as const;

export const CLUSTER_REGISTRATION_CONNECTION_STATUS_MAP = computedLocale<Record<ClusterRegistration['connection_status'], { icon: string; text: string }>>(() => ({
  [CONNECTION_STATUS.UNKNOWN]: {
    icon: STATUS_ICON_WARNING_O,
    text: i18n.t('Unknown'),
  },
  [CONNECTION_STATUS.HEALTHY]: {
    icon: STATUS_ICON_CHECK_O,
    text: i18n.t('Healthy'),
  },
  [CONNECTION_STATUS.FAILED]: {
    icon: STATUS_ICON_TIMES_O,
    text: i18n.t('Failed'),
  },
  [CONNECTION_STATUS.CONFIGURING]: {
    icon: STATUS_ICON_LOADING,
    text: i18n.t('Configuring'),
  },
  [CONNECTION_STATUS.PENDING]: {
    icon: STATUS_ICON_CLOCK,
    text: i18n.t('Pending'),
  },
  [CONNECTION_STATUS.REGISTRATION_FAILED]: {
    icon: STATUS_ICON_TIMES_O,
    text: i18n.t('Registration failed'),
  }
}));
